export default __webpack_public_path__ + "static/1193-6650edb3d6d18c664d46b27a2a5e0fc7.gif";